import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const TradeAnalytics: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
        Trade Analytics
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Trade analytics and insights will be displayed here.
        </Typography>
      </Paper>
    </Box>
  );
};

export default TradeAnalytics;

